import React from "react";
import { Form } from "react-bootstrap"
import { useDebounce } from "@whitespace/whitespace-utils";
import { useState, useEffect, ChangeEvent } from "react";
import { ISelectableListSearchProps } from '../../interfaces/Components/SelectableList/ISelectableListSearchProps';

export const SelectableListSearch = ({label, onChange, uniqueName} : ISelectableListSearchProps) => {

    const [searchTerm, setSearchTerm] = useState("");

    const debouncedSearchTerm = useDebounce<string>(searchTerm, 500);

    const termChanged = (event : ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.currentTarget.value);
    }

    useEffect(
        () => {
                onChange(debouncedSearchTerm);
        }, [debouncedSearchTerm, onChange]);
    
    return  <Form.Group className="mb-0">
                <Form.Label htmlFor={`${uniqueName}-selectable-list-search`} className="visually-hidden">{label}</Form.Label>
                <Form.Control id={`${uniqueName}-selectable-list-search`} type="text" value={searchTerm} onChange={termChanged}/>
            </Form.Group>
}